import { useTranslation } from 'react-i18next';
import { portfolioProjects } from '@/mocks/landingData';

const linkIcons: Record<string, string> = {
  website: 'ri-global-line',
  github: 'ri-github-line',
  telegram: 'ri-telegram-line',
  demo: 'ri-play-circle-line',
};

export default function PortfolioSection() {
  const { t } = useTranslation();

  return (
    <section id="portfolio" className="relative w-full py-20 md:py-32 bg-dark-900">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white">
            {t('portfolio.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-blue to-neon-purple">
              {t('portfolio.title2')}
            </span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-xl mx-auto">
            {t('portfolio.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {portfolioProjects.map((project) => (
            <div
              key={project.id}
              className="group relative p-5 md:p-6 rounded-2xl bg-dark-500 border border-white/5 hover:border-neon-blue/30 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_8px_40px_-12px_#00D9FF20] cursor-pointer overflow-hidden"
            >
              <div
                className="absolute top-0 left-0 w-full h-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{ background: `linear-gradient(90deg, ${project.color}, transparent)` }}
              />
              <div
                className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center mb-5"
                style={{ backgroundColor: `${project.color}15` }}
              >
                <i
                  className={`${project.icon} text-xl md:text-2xl`}
                  style={{ color: project.color }}
                />
              </div>
              <div className="flex flex-wrap gap-2 mb-4">
                {project.tags.map((tag) => (
                  <span
                    key={tag}
                    className="inline-block px-3 py-1 rounded-full text-[10px] md:text-xs font-medium"
                    style={{
                      backgroundColor: `${project.color}15`,
                      color: project.color,
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold text-white mb-2">
                {project.name}
              </h3>
              <p className="text-xs md:text-sm text-gray-400 leading-relaxed">
                {t(`portfolio.project_${project.id}_desc`)}
              </p>
              <div className="mt-5 flex flex-wrap gap-3">
                {project.links?.map((link) => (
                  <a
                    key={link.type}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-xs font-medium hover:opacity-80 transition-opacity duration-300"
                    style={{ color: project.color }}
                  >
                    <i className={`${linkIcons[link.type]} text-sm`} />
                    <span>{t(`portfolio.link_${link.type}`)}</span>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
